import { Control } from 'ol/control';
import { ReactElement } from 'react';

const CustomControls = ({ children }: { children: Array<ReactElement<Control> | null> }) => {
  return <div>{children}</div>;
};

export default CustomControls;
